import clsx from 'clsx';
import { useEffect, useState } from 'react';

// Components
import { ActiveBar } from '@/components/composite/SelectedProfiles/ActiveBar';
import { DefaultAvatar as Avatar, DefaultAvatarProps } from '@/components/base/Avatar';
import Tooltip from '@/components/base/Tooltip';

// Providers
import { useProfilesStore } from '@/utils/zustand/providers/profiles-provider';

// Type
import type { SpGroupType } from '@/utils/hooks/swr/group/useSPGroups';
import type { SelectedProfilesProps } from '@/components/composite/SelectedProfiles';

type GroupItemProps = Required<SelectedProfilesProps> & {
    group: SpGroupType;
    isActive: boolean;
};

const getSize = (itemsSize: SelectedProfilesProps['itemsSize']) => {
    if (window.innerWidth < 640 || itemsSize === 'md') {
        return 'md';
    }

    return 'base';
};

export function GroupItem({ group, isActive, itemsSize }: GroupItemProps) {
    const [avatarSize, setAvatarSize] = useState<DefaultAvatarProps['size']>(getSize(itemsSize));
    const { resetActiveSocialProfile } = useProfilesStore((state) => state);

    const handleResize = () => {
        setAvatarSize(getSize(itemsSize));
    };

    useEffect(() => {
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Tooltip
            interactive
            arrow={false}
            offset={[0, 4]}
            variant="profile_tooltip"
            content={group.name}>
            <button
                className={clsx('relative flex rounded-md focus:ring-0 focus:ring-offset-0', {
                    'cursor-default': isActive
                })}
                onClick={resetActiveSocialProfile}>
                <Avatar
                    size={avatarSize}
                    radius="rounded-md"
                    selected={isActive}
                    url={group.image}
                    fallback={group.name.substring(0, 2)}
                />
                <ActiveBar isActive={isActive} />
            </button>
        </Tooltip>
    );
}
